import React, { useEffect } from 'react';

// Styles & Assets
import styles from './PreconfigurationPage.module.css';

// Hooks
import { useState } from 'react';
import useSearchbar from '../../hooks/useSearchbar';

// Components
import Table from '../../components/UI/Table/Table';
import ErrorSpinnerWrapper from '../../components/UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';
import ToolbarPreconfigPage from '../../components/PreconfigurationPage/ToolbarPreconfigPage/ToolbarPreconfigPage';

// Interfaces
import { Preconfiguration } from '../../interfaces/Preconfigurations';
import { FilterGeneric } from '../../interfaces/Filters';
import { usePreconfigurations } from '../../hooks/preconfig-hooks';


const PreconfigurationPage: React.FC = () => {

    const { isLoading, error, preconfigs, columns } = usePreconfigurations();

    const getFilter = useSearchbar(columns);
    const [filterSearchbar, setFilterSearchbar] = useState<FilterGeneric<Preconfiguration>>(() => getFilter(''));
    const [selectedPathologiesIDs, setSelectedPathologiesIDs] = useState<number[]>([]);
    const [selectedProfileIDs, setSelectedProfileIDs] = useState<number[]>([]);

    const handleConfirmFilters = (temporalIDs: number[], selectedProfileIDs: number[]) => {
        setSelectedPathologiesIDs(temporalIDs);
        setSelectedProfileIDs(selectedProfileIDs);
    };
    const handleChangeSearchbar = (evt: React.ChangeEvent<HTMLInputElement>) =>
        setFilterSearchbar(() => getFilter(evt.target.value));

    const filteredPreconfigs = preconfigs.filter(preconfig =>
        filterSearchbar()(preconfig) &&
        (selectedPathologiesIDs.length === 0 || preconfig.pathologies?.some(p => selectedPathologiesIDs.includes(p.id))) &&
        (selectedProfileIDs.length === 0 || preconfig.profiles?.some(p => selectedProfileIDs.includes(p.id)))
    );

    return (
        <div className='pageContainer'>
            <ToolbarPreconfigPage
                selectedPathologiesIDs={selectedPathologiesIDs}
                selectedProfileIDs={selectedProfileIDs}
                handleChangeSearchbar={handleChangeSearchbar}
                handleConfirmFilters={handleConfirmFilters}
            />
            <div className={styles.contentContainer}>
                <ErrorSpinnerWrapper loading={isLoading} error={error}>
                    <Table
                        rows={filteredPreconfigs}
                        columns={columns}
                        nohoverRow
                    />
                </ErrorSpinnerWrapper>
            </div>
        </div>
    );
};

export default PreconfigurationPage;